"use client"

import { GetSearchResultsHash200PCandidatesItem } from "openapi/api/model"
import { useState, useMemo } from "react"

export interface SearchFilters {
  searchTerm: string
  locationFilter: string
  matchScoreFilter: string
}



export function useSearchFilters(candidates: GetSearchResultsHash200PCandidatesItem[]) {
  const [filters, setFilters] = useState<SearchFilters>({
    searchTerm: "",
    locationFilter: "all",
    matchScoreFilter: "all",
  })
  

  const filteredCandidates = useMemo(() => {
    return candidates?.filter((candidate) => {
      const profile = candidate.profile

      if (filters.searchTerm) {
        const searchLower = filters.searchTerm.toLowerCase()
        const matchesName = profile?.full_name?.toLowerCase().includes(searchLower)
        const matchesCompany = profile?.experiences?.[0]?.company?.toLowerCase().includes(searchLower)
        const matchesSkills = profile?.skills?.some((skill:string) => skill.toLowerCase().includes(searchLower))
        const matchesHeadline = profile?.headline?.toLowerCase().includes(searchLower)

        if (!matchesName && !matchesCompany && !matchesSkills && !matchesHeadline) {
          return false
        }
      }

      if (filters.locationFilter !== "all") {
        const candidateCountry = profile?.country_full_name || profile?.country
        if (filters.locationFilter === "Canada" && candidateCountry !== "Canada") {
          return false
        }
        if (filters.locationFilter === "USA" && candidateCountry !== "United States") {
          return false
        }
      }

      //if (filters.matchScoreFilter !== "all") {
      //  const score = candidate.talentIntelligence?.score || 0
      //  if (filters.matchScoreFilter === "excellent" && score < 0.9) {
      //    return false
      //  }
      //  if (filters.matchScoreFilter === "good" && (score < 0.8 || score >= 0.9)) {
      //    return false
      //  }
      //  if (filters.matchScoreFilter === "fair" && score >= 0.8) {
      //    return false
      //  }
      //}

      return true
    })
  }, [candidates, filters])

  return {
    filters,
    setFilters,
    filteredCandidates,
  }
}
